import { eventService } from './event-service';
import { ministryService } from './ministry-service';
import { schoolService } from './school-service';
import { productService} from "./product-service";
import { Event } from '../models/event/event';
import { Ministry } from '../models/ministry/ministry';
import { School } from '../models/school/school';
import { Language } from '../constants/language';
import {Product} from "../models/product/product";

export interface HomePageData {
  upcomingEvents: Event[];
  featuredMinistries: Ministry[];
  featuredSchools: School[];
  featuredProducts: Product[];
}

class HomeService {
  /**
   * Load all home page data
   */
  async loadHomePageData(language: Language): Promise<HomePageData> {
    try {
      const [eventsResult, ministriesResults, schoolsResult, productResult] = await Promise.allSettled([
        eventService.getUpcomingEvents(language),
        ministryService.getFeaturedMinistries(language),
        schoolService.getFeaturedSchools(language),
        productService.getFeaturedProducts(language)
      ]);

      const upcomingEvents = this.extractEvents(eventsResult);
      const featuredMinistries = this.extractMinistries(ministriesResults);
      const featuredSchools = this.extractSchools(schoolsResult);
      const featuredProducts = this.extractProducts(productResult);

      return {
        upcomingEvents,
        featuredMinistries,
        featuredSchools,
        featuredProducts
      };
    } catch (error) {
      console.error('Error loading home page data:', error);
      return {
        upcomingEvents: [],
        featuredMinistries: [],
        featuredSchools: [],
        featuredProducts: [],
      };
    }
  }

  /*****************
   * Helper Methods
   * ****************/
  private extractEvents(result: PromiseSettledResult<Event[]>): Event[] {
      return result.status === 'fulfilled' ? result.value : [];
  }

  private extractMinistries(result: PromiseSettledResult<Ministry[]>): Ministry[] {
      return result.status === 'fulfilled' ? result.value : [];
  }

  private extractSchools(result: PromiseSettledResult<School[]>): School[] {
      return result.status === 'fulfilled' ? result.value : [];
  }

  private extractProducts(result: PromiseSettledResult<Product[]>): Product[] {
      return result.status === 'fulfilled' ? result.value : [];
  }
}

export const homeService = new HomeService();
